export default __webpack_public_path__ + "static/media/instagram-logo.cdd23d90.svg";